import { useMutation, useQueryClient } from '@tanstack/react-query'
import { approveTicket, rejectTicket } from '../api/ticketRequestApi'
import type { TicketApprove, TicketReject } from '../types'

/**
 * Onay/ret mutation'ları. Başarıda liste + KPI özet sorguları geçersiz kılınır (durum yansır).
 * Hata (ör. 409 optimistic lock / geçersiz durum) durumunda da liste geçersiz kılınır ki satırın
 * `modDate`'i tazelensin ve kullanıcı güncel veriyle tekrar deneyebilsin.
 */
export function useApproveReject() {
  const qc = useQueryClient()
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ['ticket-requests'] })
    qc.invalidateQueries({ queryKey: ['ticket-summary'] })
  }

  const approve = useMutation({
    mutationFn: ({ id, body }: { id: number; body: TicketApprove }) => approveTicket(id, body),
    onSettled: invalidate,
  })

  const reject = useMutation({
    mutationFn: ({ id, body }: { id: number; body: TicketReject }) => rejectTicket(id, body),
    onSettled: invalidate,
  })

  return { approve, reject }
}
